import lodash from "lodash";
import util from "./util";

export default {
  install(Vue) {
    Vue.prototype.$util = util;
    Vue.prototype.$lodash = Vue.prototype.$_ = lodash;
  },
};
